import LoadingButton from '@atlaskit/button/loading-button';
import Button from '@atlaskit/button/standard-button';
import { useFlags } from '@atlaskit/flag';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { getFlagForError, getFlagForSuccess } from '@atlassian/developer-space';
import { ANALYTICS_ACTION_CLICKED, ANALYTICS_SUBJECT_BUTTON, UI_EVENT_TYPE, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { deletePartnerContact } from '@atlassian/mpac-api-client';
import { useFeatureFlags } from '@atlassian/mpac-feature-flags';
import { showModalIfTwoSVSessionExpires, useTwoStepAuthTimedOut } from '@atlassian/mpac-ui';
import { log } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import { ANALYTICS_SUBJECT_ID_DELETE_NOW_CONTACT_MODAL_TRIGGER } from '../../../analytics/Events';
import { CONTACT_FAILED_DELETE_FLAG, CONTACT_SUCCESS_DELETE_FLAG, DELETE_CONTACT_FAILED, DELETE_CONTACT_FAILED_DESCRIPTION, DELETE_TEAM_MEMBER_FAILED, DELETE_TEAM_MEMBER_FAILED_DESCRIPTION, TEAM_MEMBER_FAILED_DELETE_FLAG, TEAM_MEMBER_SUCCESS_DELETE_FLAG } from '../AddManageContactModal/AddManageContactModal.label';
import { DELETE_CONTACT, DELETE_TEAM_MEMBER } from '../AddManageContactModal/AddManageContactModal.types';
const DeleteContactConfirmationModal = props => {
  const {
    showFlag
  } = useFlags();
  const fireAnalyticsEvent = useAnalyticsEvents();
  const [deletingContactInProgress, setDeletingContactInProgress] = useState(false);
  const {
    showCopyChangesForPartnerContact
  } = useFeatureFlags();
  const {
    setTwoStepAuthTimedOut
  } = useTwoStepAuthTimedOut();
  const onDeleteContact = async () => {
    setDeletingContactInProgress(true);
    try {
      await deletePartnerContact(props.mpacBaseUrl, props.contactResource);
      setDeletingContactInProgress(false);
      props.onDelete();
      showFlag(getFlagForSuccess(showCopyChangesForPartnerContact ? TEAM_MEMBER_SUCCESS_DELETE_FLAG : CONTACT_SUCCESS_DELETE_FLAG, "".concat(props.contactName, " has been successfully deleted")));
      fireAnalyticsEvent({
        eventType: UI_EVENT_TYPE,
        actionSubjectId: ANALYTICS_SUBJECT_ID_DELETE_NOW_CONTACT_MODAL_TRIGGER,
        attributes: {
          action: ANALYTICS_ACTION_CLICKED,
          actionSubject: ANALYTICS_SUBJECT_BUTTON
        }
      });
    } catch (error) {
      setDeletingContactInProgress(false);
      showModalIfTwoSVSessionExpires(error, setTwoStepAuthTimedOut);
      showFlag(getFlagForError(showCopyChangesForPartnerContact ? TEAM_MEMBER_FAILED_DELETE_FLAG : CONTACT_FAILED_DELETE_FLAG, showCopyChangesForPartnerContact ? DELETE_TEAM_MEMBER_FAILED : DELETE_CONTACT_FAILED));
      log.error('PartnerContactsActions', showCopyChangesForPartnerContact ? DELETE_TEAM_MEMBER_FAILED_DESCRIPTION : DELETE_CONTACT_FAILED_DESCRIPTION, {
        error
      });
    }
  };
  return /*#__PURE__*/React.createElement(ModalTransition, null, /*#__PURE__*/React.createElement(Modal, {
    onClose: props.onCloseModal
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, {
    appearance: "danger"
  }, showCopyChangesForPartnerContact ? DELETE_TEAM_MEMBER : DELETE_CONTACT)), /*#__PURE__*/React.createElement(ModalBody, null, "Are you sure you want to remove ", props.contactName, "?"), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(LoadingButton, {
    appearance: "danger",
    isLoading: deletingContactInProgress,
    onClick: onDeleteContact
  }, "Delete now"), /*#__PURE__*/React.createElement(Button, {
    onClick: props.onCloseModal
  }, "Cancel"))));
};
export default DeleteContactConfirmationModal;